import { useParams } from "react-router-dom";
import { Skeleton } from "@/components/atoms";
import { DispatchSettingsDetails } from "@/components/organisms";
import { DispatchSettingsEditor } from "@/components/organisms/DispatchSettings/DispatchSettingsEditor";
import { OffloadingDetailsInDispatch } from "@/components/organisms/DispatchSettings/OffloadingDetailsInDispatch";
import { OffloadingEditorInDispatch } from "@/components/organisms/DispatchSettings/OffloadingEditorInDispatch";
import { useGetAddOnsQuery } from "@/redux/apis/addOn/addOnApi";
import { useGetDispatchSettingsQuery } from "@/redux/apis/config/business/dispatchSettings";
import { useAppSelector } from "@/redux/hooks";
import { addOnItemSelector } from "@/redux/slices/addOn/selectors";
import { clsx } from "@/utils";

export const DispatchSettings = () => {
  const { mode, type } = useParams();
  const { isFetching: isFetchingDispatchSettings } = useGetDispatchSettingsQuery();
  const { isFetching: isFetchingAddOns } = useGetAddOnsQuery({ search: "", sort: "" }, { refetchOnMountOrArgChange: true });
  const offloading = useAppSelector(addOnItemSelector("offloading"));
  const isFetching = isFetchingDispatchSettings || isFetchingAddOns;

  if (isFetching) return <Skeleton />;

  return (
    <>
      <div className={clsx({ "pointer-events-none opacity-50": mode === "edit" && type === "offloading" })}>
        {mode === "edit" && !type ? <DispatchSettingsEditor /> : <DispatchSettingsDetails />}
      </div>
      {offloading && (
        <div className={clsx({ "pointer-events-none opacity-50": mode === "edit" && !type })}>
          {mode === "edit" && type === "offloading" ? <OffloadingEditorInDispatch /> : <OffloadingDetailsInDispatch />}
        </div>
      )}
    </>
  );
};
